'use client';

import React from 'react';

interface DialogPolyfillType {
  registerDialog(dialog: HTMLDialogElement): void;
  forceRegisterDialog(dialog: HTMLDialogElement): void;
}

let dialogPolyfill: DialogPolyfillType | null = null;

export const useDialogPolyfill = (ref: React.MutableRefObject<HTMLDialogElement | null>) => {
  React.useEffect(() => {
    if (window.HTMLDialogElement === undefined && ref.current) {
      if (dialogPolyfill) {
        dialogPolyfill.registerDialog(ref.current);
      } else {
        import('dialog-polyfill').then(polyfill => {
          polyfill.default.registerDialog(ref.current as HTMLDialogElement);
          dialogPolyfill = polyfill.default;
        });
      }
    }
  }, [ref]);
};
